<template>
  <div id="page-product-details">
    <section-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Create Section"
      />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.sections.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SectionForm from '@/views/pages/facilities/sections/SectionForm';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "SectionCreate",
  components: {
    SectionForm,
  },
  mixins: [NotificationMixin,SaveModelMixin],
  data() {
    return {
      model: {
      },
      loading: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      const references = [
        'ClassOfRisk_FK',
        'SectionClassificationType_FK',
      ]

      const dates = [
          'InceptionDate',
          'ExpiryDate',
      ]

      this.setReferences(references);
      this.setDates(dates);

      params.Facility_FK = this.id;

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.facilities.sections.create(params);
        this.notifySuccess('Section created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Section failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
